import { createStore } from "vuex";

const store = createStore({
  state: {
    lineId: '',
    lineName: '',
    callerId: '',//'SW3001',
    branchName: '',//'testbranch',
    isAuthenticate: false,//true,
  },
  mutations: {
    setAuthen: async function (state, val) {
      state.callerId = val.callerId;
      state.branchName = val.branchName;
      state.isAuthenticate = true;
    },
    setLineId: async function (state, val) {
      state.lineId = val.userId;
      state.lineName = val.displayName;
    }
  },
  actions: {
    
  }
});
export default store;
